<section class="container quantum-container">
  <div class="text-section">
    <h1>Digital Marketing Services That Drive Growth</h1>
    <p>
      MALtech is at the forefront of digital innovation, driving measurable growth through data-driven marketing strategies.
We leverage SEO, paid media, and analytics to reach the right audience with precision and impact.
Our solutions empower businesses to grow visibility, engagement, and revenue smarter, faster, and sustainably.
    </p>
    

    <a routerLink="/contact" href="/contact" class="btn consult-btn"> Get Expert Consultation</a>
  </div>

  <div class="image-section">
    <img
      src="assets/images/degitalmarketing/quantum.webp"
      alt="Digital Mearketing Illustration"
      loading="lazy"
    />
  </div>
</section>

<section class="services-container">
  <div class="container">
    <div class="intro">
      <h2 class="services-title">Our Digital Marketing Services</h2>
    </div>

    <div class="cards-grid">
      <div class="service-card" *ngFor="let service of services">
        <div class="card-img" [ngClass]="service.bgClass">
          <img
            [src]="service.img"
            [alt]="service.title"
            class="service-img"
            loading="lazy"
          />
        </div>
        <h3 class="text-logo-color">{{ service.title }}</h3>
        <p>{{ service.description }}</p>
      </div>
    </div>
  </div>
</section>

<section class="tools-section">
  <div class="container">
    <h2>Tools & Platforms We Use</h2>

    <div class="tools-grid">
      <div class="tool-card" *ngFor="let tool of tools">
        <div class="content">
          <img
            [src]="tool.logo"
            [alt]="tool.name"
            class="logo"
            loading="lazy"
          />
          <p class="description">{{ tool.description }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="why-maltech">
  <div class="container">
    <h2 class="text-center mb-4">Why MALtech</h2>
    <p>
        At MALtech, we deliver measurable growth with proven results  from
        <strong>120% organic traffic gains in 6 months</strong> to
        <strong>5x ROI on ad spend</strong>. By blending data-driven strategies
        with creative innovation across SEO, social media, paid ads, content,
        and email marketing, we help brands scale with transparency, engagement,
        and lasting impact.
      </p>

    <div class="why-grid">
      <div class="why-card" *ngFor="let item of whyMaltech">
        <div class="icon-wrap">
          <i class="bi" [ngClass]="item.icon"></i>
        </div>

        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p>
      </div>
    </div>
  </div>
</section>



<section class="build-solutions" id="get-start">
  <div class="container">
    <div class="container-build">
      <h2>Let’s Build Intelligent Solutions Together</h2>
      <p>
        Partner with MALtech to transform your business with powerful SEO,
        social media campaigns, and result-driven marketing strategies.
      </p>
      <a
        [routerLink]="['/contact']" [href]="['/contact']"
        class="btn cta-btn btn-primary"
        rel="noopener noreferrer"
        aria-label="Contact Us"
      >
        Contact Us 
      </a>
    </div>
  </div>
</section>
